import { render, staticRenderFns } from "./SecaoTabela.vue?vue&type=template&id=32975265&scoped=true&"
import script from "./SecaoTabela.vue?vue&type=script&lang=ts&"
export * from "./SecaoTabela.vue?vue&type=script&lang=ts&"
import style0 from "./SecaoTabela.vue?vue&type=style&index=0&id=32975265&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32975265",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VDataTable,VIcon})
